import React from "react";
import { formatComptableMaisPasTrop } from "../../../services/function";
import { useProductionStore } from "../../../stores/production";

const InvoicesProduction = () => {
  const { production2 } = useProductionStore();

  return (
    <table className="min-w-full font-Nunito bg-white shadow-lg border border-gray-100 rounded-2xl h-auto overflow-x-scroll overflow-y-scroll">
      {production2?.customers?.map((customer: any, index: any) => (
        <React.Fragment key={index}>
          <thead className="w-full border border-gray-300 px-4 py-2 bg-thead text-left">
            <tr>
              <th className="px-4 py-2 bg-thead text-left" colSpan={7}>
                {customer.customerName}
              </th>
            </tr>
            <tr className="h-12">
              <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
                Date
              </th>
              <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
                Service
              </th>
              <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
                Numéro Facture
              </th>
              <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
                Montant HT
              </th>
              <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
                Montant TVA
              </th>
              <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
                Montant TTC
              </th>
              <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
                Solde
              </th>
            </tr>
          </thead>
          <tbody>
            {customer.invoices.map((invoice: any, index: any) => (
              <tr key={index} className="h-8 border-gray-300">
                <td className="border border-gray-300 px-4 py-2 text-left">
                  {invoice.date}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-left">
                  {invoice.departmentName}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-left">
                  {formatComptableMaisPasTrop(invoice.invoiceNumber)}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-left">
                  {formatComptableMaisPasTrop(invoice.amountExclVAT)}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-left">
                  {formatComptableMaisPasTrop(invoice.amountVAT)}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-left">
                  {formatComptableMaisPasTrop(invoice.totalAmount)}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-left">
                  {formatComptableMaisPasTrop(invoice.balance)}
                </td>
              </tr>
            ))}
            <tr className="h-8 bg-gray-100">
              <td className="border border-gray-300 px-4 py-2 text-left ">
                TOTAL
              </td>
              <td className="border border-gray-300 px-4 py-2 text-left"></td>
              <td className="border border-gray-300 px-4 py-2 text-left"></td>
              <td className="border border-gray-300 px-4 py-2 text-left">
                {formatComptableMaisPasTrop(customer.totals.totalAmountExclVAT)}
              </td>
              <td className="border border-gray-300 px-4 py-2 text-left">
                {formatComptableMaisPasTrop(customer.totals.totalAmountVAT)}
              </td>
              <td className="border border-gray-300 px-4 py-2 text-left">
                {formatComptableMaisPasTrop(customer.totals.totalAmount)}
              </td>
              <td className="border border-gray-300 px-4 py-2 text-left">
                {formatComptableMaisPasTrop(customer.totals.totalBalance)}
              </td>
            </tr>
          </tbody>
        </React.Fragment>
      ))}
      <tfoot>
        <tr className="border-gray-300 bg-gray-200 h-8 w-full">
          <td className="border border-gray-300 px-4 py-2 text-left w-44">
            Total des totaux
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left"></td>
          <td className="border border-gray-300 px-4 py-2 text-left"></td>
          <td className="border border-gray-300 px-4 py-2 text-left">
            {formatComptableMaisPasTrop(
              production2?.totals?.totalAmountExclVAT
            )}
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left">
            {formatComptableMaisPasTrop(production2?.totals?.totalAmountVAT)}
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left">
            {formatComptableMaisPasTrop(production2?.totals?.totalAmount)}
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left">
            {formatComptableMaisPasTrop(production2?.totals?.totalBalance)}
          </td>
        </tr>
      </tfoot>
    </table>
  );
};

export default InvoicesProduction;
